export default __webpack_public_path__ + "static/media/party-vaky-super.79f36926.gif";